<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">

                

                <div class="col-md-10 col10 mt-2">

                    <h2 > भुगतान लिंक क्या है</h2>
                </div>

                           
                <div class="col-md-10 col10 mt-4" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')" id="108">
                    <h2><b>कार्यप्रवाह</b></h2>
                    <label for="">नीचे दिया गया GIF भुगतान लिंक के वर्कफ़्लो को दर्शाता है।</label>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a> 
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="9">
                    <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/mR2MaKeeOEk"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')" id="108">
                    <img src="./assets/GIF/Payment Link workflow gif.gif" width="95%" height="89%" alt=""
                        style="border-radius: 10px;">
                </div>
                <div class="col-md-12 " (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')" id="10">

                    <h2 > भुगतान लिंक क्या है</h2>
                                      <label for="" class="spn mt-3   " >पे जी में भुगतान लिंक अनुभाग
                        व्यवसायों को अपने ग्राहकों के साथ भुगतान लिंक बनाने और साझा करने में सक्षम
                        बनाता है। भुगतान लिंक वे यूआरएल हैं जो ग्राहकों को एक सुरक्षित भुगतान पृष्ठ
                        पर ले जाते हैं जहां वे किसी विशिष्ट उत्पाद, सेवा या चालान के लिए भुगतान कर
                        सकते हैं। ये लिंक विभिन्न संचार चैनलों जैसे ईमेल, एसएमएस, चैट ऐप्स आदि के
                        माध्यम से साझा किए जाते हैं। पे जी द्वारा प्रदान किए गए भुगतान लिंक व्यवसायों
                        के लिए एक पूर्ण वेबसाइट या अपने मौजूदा प्लेटफ़ॉर्म के साथ एकीकरण की आवश्यकता
                        के बिना जल्दी से ऑनलाइन भुगतान स्वीकार करना शुरू करने का एक शानदार तरीका है।
                        . यह ग्राहकों के लिए भुगतान प्रक्रिया को सरल बनाता है और व्यवसायों को
                        निर्बाध भुगतान अनुभव प्रदान करके अपना राजस्व बढ़ाने में मदद करता है।
                    </label>
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="11">
                  
                    <h2 >
                        भुगतान लिंक के लाभ:
                    </h2>
                   
                    <label for="" class="mt-3 spn" >भुगतान लिंक व्यवसायों और व्यक्तियों
                        के लिए कई लाभ प्रदान करते हैं, जिससे भुगतान भेजने और प्राप्त करने की
                        प्रक्रिया अधिक कुशल और सुविधाजनक हो जाती है। यहां कुछ प्रमुख लाभ दिए गए हैं|
                    </label>

                    <h5 class="mt-4" >आसान साझाकरण: </h5>
                   
                    <label for="" class="mt-3 spn" >भुगतान लिंक उपयोगकर्ताओं को ईमेल,
                        मैसेजिंग ऐप या सोशल मीडिया जैसे विभिन्न चैनलों के माध्यम से एक क्लिक करने
                        योग्य लिंक साझा करने की अनुमति देता है, जिससे यह भुगतानकर्ता और प्राप्तकर्ता
                        दोनों के लिए सुविधाजनक हो जाता है। </label>

                    <h5 class="mt-4" >किसी भौतिक उपस्थिति की आवश्यकता नहीं: </h5>
                    
                    <label for="" class="mt-3 spn" >भुगतान लिंक लेनदेन के दौरान भौतिक
                        उपस्थिति की आवश्यकता को समाप्त करते हैं, जो विशेष रूप से दूरस्थ या डिजिटल
                        व्यापार लेनदेन में उपयोगी है।
                    </label>

                    <h5 class="mt-4" >त्वरित लेनदेन: </h5>
                    
                    <label for="" class="mt-3 spn" >भुगतान लिंक पारंपरिक भुगतान विधियों
                        की तुलना में तेज़ लेनदेन की सुविधा प्रदान करते हैं, क्योंकि उपयोगकर्ता कुछ
                        ही क्लिक के साथ भुगतान प्रक्रिया पूरी कर सकते हैं।

                    </label>

                    <h5 class="mt-4" >वास्तविक समय पुष्टि: </h5>
                    
                    <label for="" class="mt-3 spn" >दोनों पक्षों को भुगतान की तुरंत
                        पुष्टि मिल जाती है, जिससे धन के भुगतान की प्रतीक्षा में लगने वाला समय और
                        अनिश्चितता कम हो जाती है।
                    </label>

                    <h5 class="mt-4" >सुरक्षित लेनदेन: </h5>

                    <label for="" class="mt-3 spn" >भुगतान लिंक अक्सर सुरक्षित और
                        एन्क्रिप्टेड चैनलों का उपयोग करते हैं, जिससे लेनदेन के दौरान वित्तीय जानकारी
                        की सुरक्षा सुनिश्चित होती है।
                    </label>

                    <h5 class="mt-4" >एकाधिक भुगतान विकल्प: </h5>
                   
                    <label for="" class="mt-3 spn" >भुगतान लिंक को विभिन्न भुगतान
                        विधियों, जैसे क्रेडिट/डेबिट कार्ड, डिजिटल वॉलेट, या बैंक हस्तांतरण को
                        स्वीकार करने के लिए कॉन्फ़िगर किया जा सकता है, जो भुगतानकर्ताओं को लचीलापन
                        प्रदान करता है। </label>

                    <h5 class="mt-4" >अनुकूलन: </h5>
             
                    <label for="" class="mt-3 spn" >व्यवसाय ग्राहकों को स्पष्टता प्रदान
                        करने के लिए चालान जानकारी, देय तिथियां, या आइटमयुक्त सूचियों जैसे विवरणों के
                        साथ भुगतान लिंक को अनुकूलित कर सकते हैं।
                    </label>
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="12">
                    <h2 >पेमेंट लिंक का कहाँ इस्तेमाल करें: </h2>
                   
                    <label for=""  class="spn mt-3">लेनदेन को सुविधाजनक बनाने के लिए
                        विभिन्न उद्योगों में विभिन्न संदर्भों में भुगतान लिंक का उपयोग किया जाता है।
                        यहां कुछ सामान्य परिदृश्य दिए गए हैं जहां भुगतान लिंक का अक्सर उपयोग किया
                        जाता है:</label>
                    <h5 class="mt-4" >ई-कॉमर्स: </h5>
                   
                    <label for="" class="mt-3 spn" >ऑनलाइन रिटेल में, व्यवसाय अक्सर
                        विशिष्ट उत्पादों या सेवाओं के लिए भुगतान लिंक उत्पन्न करते हैं। ग्राहक सीधे
                        भुगतान करने के लिए लिंक पर क्लिक कर सकते हैं, जिससे चेकआउट प्रक्रिया सरल हो
                        जाएगी। </label>

                    <h5 class="mt-4" >चालान-प्रक्रिया: </h5>
                   
                    <label for="" class="mt-3 spn" >व्यवसाय और फ्रीलांसर चालान में
                        भुगतान लिंक का उपयोग करते हैं। पारंपरिक भुगतान विधियों के बजाय, प्राप्तकर्ता
                        चालान का निपटान करने के लिए भुगतान लिंक पर क्लिक कर सकते हैं, जिससे भुगतान
                        प्रक्रिया अधिक सुविधाजनक हो जाती है। </label>

                    <h5 class="mt-4" >सेवा प्रदाताओं:</h5>

                    <label for="" class="mt-3 spn" >पेशेवर और सेवा प्रदाता, जैसे
                        सलाहकार या ठेकेदार, अपनी सेवाओं के लिए भुगतान का अनुरोध करने के लिए भुगतान
                        लिंक का उपयोग कर सकते हैं। यह विधि दोनों पक्षों के लिए भुगतान प्रक्रिया को
                        सरल बनाती है। </label>

                    <h5 class="mt-4" >दान और धन उगाही: </h5>
                    
                    <label for="" class="mt-3 spn" >गैर-लाभकारी संगठन और धन उगाहने वाले
                        अभियान चलाने वाले व्यक्ति अक्सर दान इकट्ठा करने के लिए भुगतान लिंक का उपयोग
                        करते हैं। यह समर्थकों को योगदान देने का एक सीधा तरीका प्रदान करता है।

                    </label>

                    <h5 class="mt-4" >कार्यक्रम पंजीकरण: </h5>
               
                    <label for="" class="mt-3 spn" >कार्यक्रम आयोजित करते समय, आयोजक
                        टिकट बिक्री या पंजीकरण शुल्क के लिए भुगतान लिंक का उपयोग कर सकते हैं।
                        उपस्थित लोग अपनी भागीदारी के लिए भुगतान करने के लिए लिंक पर क्लिक कर सकते
                        हैं।
                    </label>

                   
                    <h5 class="mt-4" >सहकर्मी से सहकर्मी लेनदेन: </h5>
                    
                    <label for="" class="mt-3 spn" >व्यक्ति मित्रों, परिवार या
                        सहकर्मियों को पैसे भेजने या अनुरोध करने के लिए भुगतान लिंक उत्पन्न कर सकते
                        हैं। यह उन स्थितियों में आम है जहां बिल बांटना या खर्च साझा करना आम बात है।

                    </label>

                    <h5 class="mt-4" >सदस्यता सेवाएँ: </h5>
                   
                    <label for="" class="mt-3 spn" >सदस्यता-आधारित सेवाएं प्रदान करने
                        वाली कंपनियां प्रारंभिक साइन-अप के लिए या ग्राहकों से आवर्ती भुगतान एकत्र
                        करने के लिए भुगतान लिंक का उपयोग कर सकती हैं।

                    </label>
                 
                    <label for="" class="mt-3 spn" >भुगतान लिंक की बहुमुखी प्रतिभा उनकी
                        सरलता और उपयोग में आसानी में निहित है। वे जटिल भुगतान गेटवे या व्यापक सेटअप
                        प्रक्रियाओं की आवश्यकता के बिना वित्तीय लेनदेन को संभालने का एक सुविधाजनक
                        तरीका प्रदान करते हैं।
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2  ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                  
                    <h5 >
                        विषयसूची:
                    </h5>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#9">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro" alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="videoHover" [ngClass]="{'video':colors=='1'}"
                                    (click)="color('1')">
                                    भुगतान लिंक क्या है? </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#9">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/GIF/GIF.svg" class="tab-icon intro" alt=""> </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('108')">
                                    कार्यप्रवाह </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#10">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                               
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')" >
                                    भुगतान लिंक क्या है? </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#11">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                             
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')" >भुगतान लिंक के लाभ </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#12">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                           
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')" >भुगतान लिंक का उपयोग कहाँ किया जाता है?
                                </span>
                            </div>
                        </div>
                    </a>
                </div>

            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8" style="width:60%">
          
                <a [routerLink]="['/web-integration']">   <button class="btn btn-color" (click)="menues('Web Integration')" >
                    <img src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;वेब एकीकरण

                </button></a>
            </div>
            <div class="col-md-4   " style="width:40%">
              
                <a [routerLink]="['/create-link']">  <button class="btn btn-color" (click)="menues('Create Payment')"
                    >पेमेंट लिंक
                    कैसे क्रिएट करें

                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>